<fl-hero-container
  [foldText]="foldText"
  [header]="header"
  [heroIllustration]="heroIllustration"
></fl-hero-container>
<fl-icon-wall></fl-icon-wall>
<fl-statistical-highlights></fl-statistical-highlights>
<fl-network-infrastructure></fl-network-infrastructure>
<fl-products></fl-products>
<fl-footer></fl-footer>
